import * as React from "react";
import { getBackgroundColorClass } from "../../colors/index.mjs";
const TableRow = (props) => {
  const { type, leftBorderColor, background, className, id, onClick, children } = props;
  const BEM = () => {
    const classArray = ["table__row"];
    if (type) {
      classArray.push("table__row--" + type);
    }
    if (leftBorderColor) {
      classArray.push("table__row--left-bordered-".concat(leftBorderColor));
    }
    if (background && background !== "transparent") {
      classArray.push(getBackgroundColorClass(background));
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("tr", { className: BEM(), id, onClick }, children);
};
export {
  TableRow
};
